function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.625h30v18.75H0V5.625Z",
    style: {
      fill: "#74acdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.875h30v6.25H0v-6.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.882,15.049l1.067,2.325s.018.044.048.032c.03-.012.011-.057.011-.057l-.889-2.398M15.093,15.855c-.013.354.204.548.176.864-.028.316.145.494.185.617s-.043.196-.007.214c.036.017.115-.079.089-.254s-.158-.226-.127-.612-.158-.475-.112-.827",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.456,17.573c-.008,0-.014-.002-.018-.004-.032-.015-.02-.049-.011-.076.012-.036.029-.085.008-.15-.01-.031-.03-.067-.053-.109-.065-.118-.154-.279-.133-.516.014-.154-.032-.278-.081-.409-.05-.134-.101-.273-.095-.453l.042.002c-.006.172.044.307.092.437.051.136.098.265.084.428-.02.224.065.379.128.492.024.044.045.082.057.117.026.078.005.137-.008.176-.003.008-.006.018-.007.024.003-.001.007-.004.013-.009.025-.024.062-.098.044-.222-.008-.056-.028-.098-.051-.147-.046-.098-.097-.209-.076-.469.015-.187-.023-.304-.06-.416-.032-.098-.063-.191-.059-.322l-.407-.886.038-.017.376.818s0-.003.001-.005l.041.005c-.004.027-.006.052-.007.076l.656,1.429c.002.005.013.025.021.022.001-.001.005-.002.004-.012-.001-.009-.004-.017-.004-.017l-.89-2.399.039-.015.889,2.398s.006.014.007.03c.002.026-.009.045-.03.054-.033.014-.063-.013-.075-.044l-.614-1.337c.009.077.03.141.052.208.038.116.078.237.062.432-.02.249.029.355.073.448.023.05.045.097.054.159.02.135-.02.233-.066.267-.015.009-.027.012-.036.012Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M14.872,15l.096,2.556s0,.048.032.048.032-.048.032-.048l.096-2.556M14.758,15.826c-.147.322-.021.585-.168.865-.147.281-.055.512-.065.641-.01.129-.115.165-.089.195.027.03.137-.029.18-.201s-.06-.27.117-.614c.176-.344.036-.5.213-.807",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,17.625c-.036,0-.053-.036-.053-.069l-.055-1.47c-.021.074-.026.142-.031.212-.009.122-.019.248-.108.423-.114.223-.109.339-.104.442.002.055.005.107-.011.168-.033.133-.108.208-.163.221-.029.007-.045-.005-.052-.012-.023-.026,0-.053.019-.074.025-.028.059-.067.064-.136.002-.033-.002-.074-.007-.121-.015-.134-.036-.317.075-.528.072-.137.076-.269.082-.409.005-.143.011-.291.086-.455l.038.017c-.072.157-.077.3-.082.439-.005.145-.01.282-.086.427-.104.2-.085.375-.07.504.006.05.01.093.008.129-.006.082-.047.129-.075.16-.006.006-.013.014-.016.02.003,0,.008,0,.016-.004.032-.013.095-.067.125-.189.014-.055.012-.102.009-.156-.005-.108-.01-.23.109-.463.086-.167.095-.289.104-.407.008-.102.015-.2.069-.32l-.037-.974.042-.002.034.9s.002-.003.002-.004l.036.021c-.014.024-.025.046-.035.068l.059,1.572c0,.005.002.028.011.028s.011-.023.011-.027l.096-2.557.042.002-.096,2.556c-.003.032-.02.068-.056.068Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M14.881,14.951l-.889,2.398s-.018.044.011.057c.03.012.048-.032.048-.032l1.067-2.325M14.461,15.671c-.259.241-.243.532-.486.735-.243.203-.247.452-.305.567s-.169.108-.156.146.138.025.243-.116.048-.272.343-.523.225-.448.506-.664",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.014,17.429c-.006,0-.012-.001-.018-.004-.034-.014-.035-.053-.022-.084l.511-1.379c-.048.061-.078.121-.11.184-.055.109-.112.222-.262.349-.19.162-.23.272-.266.368-.019.052-.036.1-.074.151-.082.11-.18.151-.236.142-.03-.005-.04-.021-.043-.031-.012-.033.02-.049.046-.062.034-.017.08-.04.111-.101.015-.029.026-.069.04-.115.037-.129.088-.306.271-.459.118-.099.174-.219.232-.347.06-.13.121-.264.253-.387l.028.031c-.126.117-.186.248-.244.374-.06.132-.118.257-.243.362-.173.144-.222.314-.258.438-.014.048-.026.09-.042.122-.037.073-.093.101-.13.119-.008.004-.017.008-.022.012.003.001.008.003.016.003.035,0,.113-.026.188-.126.034-.046.05-.089.068-.14.037-.102.079-.217.278-.386.143-.122.199-.231.252-.336.046-.092.091-.179.186-.269l.339-.914.039.014-.313.844s.002-.002.004-.003l.025.033c-.022.017-.041.033-.059.049l-.547,1.475c-.002.005-.009.027,0,.03.008.003.019-.017.021-.021l1.067-2.325.038.017-1.067,2.325c-.011.025-.032.047-.057.047Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M14.909,14.909l-1.739,1.875s-.034.034-.011.057c.023.023.057-.011.057-.011l1.875-1.739M14.245,15.413c-.332.123-.428.399-.731.493-.303.095-.401.323-.499.407s-.198.035-.2.075.118.076.269-.015.149-.233.517-.352.379-.328.721-.42",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.177,16.87c-.012,0-.024-.005-.033-.014-.026-.026-.012-.063.011-.086l1-1.078c-.067.038-.119.082-.172.128-.093.08-.189.162-.376.223-.238.077-.317.163-.386.239-.037.04-.072.079-.126.111-.118.07-.224.07-.272.041-.026-.016-.029-.035-.028-.046.002-.035.038-.037.066-.039.038-.002.09-.006.141-.05.025-.021.051-.054.081-.091.084-.105.199-.249.426-.32.147-.046.244-.136.347-.232.105-.097.213-.198.382-.261l.015.039c-.162.06-.267.158-.369.252-.106.099-.207.192-.363.241-.215.067-.325.205-.406.306-.031.039-.058.073-.086.097-.062.054-.125.058-.166.06-.008.001-.019.001-.025.003.002.002.006.005.014.009.032.014.114.02.222-.045.049-.029.08-.064.117-.103.073-.08.156-.17.404-.25.179-.058.272-.137.362-.215.078-.067.152-.131.275-.178l.663-.715.031.028-.612.66s.003-.001.005-.001l.011.04c-.026.007-.051.015-.073.023l-1.069,1.153s-.018.021-.012.028c.001.001.004.003.013-.001.008-.004.014-.01.014-.01l1.876-1.74.028.031-1.875,1.739s-.011.011-.025.018c-.012.004-.021.006-.03.006Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M15.162,15.915c.017.34.21.49.172.799.083-.245-.117-.434-.106-.796M14.941,15.028l.731,1.597-.612-1.646",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M14.799,15.908c-.114.32.006.533-.147.804.17-.194.058-.446.207-.776M14.935,15.003l.064,1.755.064-1.755",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M14.467,15.762c-.228.252-.198.495-.444.687.232-.114.224-.39.488-.637M14.938,14.978l-.612,1.646.731-1.597",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b3",
    "data-name": "b",
    d: "M14.216,15.5c-.307.146-.372.381-.673.465.258-.017.356-.274.695-.402M14.951,14.956l-1.195,1.286,1.286-1.196",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M14.951,14.882l-2.325,1.067s-.044.018-.032.048.057.011.057.011l2.398-.889M14.145,15.093c-.354-.013-.548.204-.864.176s-.494.145-.617.185c-.123.04-.196-.043-.214-.007-.017.036.079.115.254.089s.226-.158.612-.127c.386.031.475-.158.827-.112",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.623,16.034c-.023,0-.04-.011-.048-.03-.014-.034.013-.063.044-.075l1.337-.613c-.077.009-.141.03-.208.052-.116.038-.237.078-.432.062-.249-.02-.355.029-.448.073-.05.023-.097.045-.159.054-.135.02-.233-.02-.267-.066-.018-.024-.013-.044-.009-.053.015-.032.049-.02.076-.011.036.012.085.029.15.008.031-.01.067-.03.109-.053.118-.065.279-.154.516-.133.154.014.278-.032.409-.081.134-.05.273-.102.453-.095l-.002.042c-.172-.006-.307.044-.437.092-.136.051-.265.098-.428.084-.224-.02-.379.065-.492.128-.044.024-.082.045-.117.057-.078.026-.137.005-.176-.008-.008-.003-.018-.006-.024-.007.001.003.004.007.009.013.024.025.098.062.222.044.056-.008.098-.028.147-.051.098-.046.209-.098.469-.076.188.015.304-.023.416-.06.098-.032.191-.062.322-.059l.886-.407.017.038-.818.376s.003,0,.005.001l-.005.041c-.027-.004-.052-.006-.076-.007l-1.429.656c-.005.002-.025.013-.022.021.003.008.026.001.03,0l2.399-.89.015.039-2.398.889s-.014.006-.03.007c-.002-.002-.004-.002-.006-.002Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M15,14.872l-2.556.096s-.048,0-.048.032.048.032.048.032l2.556.096M14.174,14.758c-.322-.147-.585-.021-.865-.168-.281-.147-.512-.055-.641-.065s-.165-.115-.195-.089c-.03.027.029.137.201.18.171.043.27-.06.614.117.344.176.5.036.807.213",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,15.149l-2.556-.096s-.015,0-.03-.005c-.024-.008-.038-.026-.038-.048,0-.036.036-.053.069-.053h0l1.47-.055c-.074-.021-.142-.026-.212-.031-.122-.009-.248-.019-.423-.108-.223-.114-.339-.109-.442-.104-.055.002-.107.005-.168-.011-.133-.033-.208-.108-.222-.163-.007-.029.005-.045.012-.052.026-.023.053,0,.074.019.028.025.067.059.136.064.033.002.074-.002.122-.008.134-.015.317-.036.528.075.137.072.269.076.409.082.143.005.291.011.455.086l-.017.038c-.157-.072-.3-.077-.439-.082-.145-.005-.282-.01-.427-.086-.2-.104-.375-.085-.504-.07-.05.006-.093.011-.129.008-.082-.006-.129-.047-.16-.075-.006-.006-.014-.013-.02-.016,0,.003.001.008.004.016.013.032.067.095.189.125.055.014.102.012.156.009.108-.005.23-.01.463.109.167.086.289.095.407.104.102.008.2.015.32.069l.974-.037.002.042-.9.034s.003.002.004.002l-.021.036c-.024-.014-.046-.025-.068-.035l-1.572.059c-.005,0-.028.002-.028.011s.023.011.027.011l2.557.096-.002.04Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M15.049,14.881l-2.398-.889s-.044-.018-.057.011c-.012.03.032.048.032.048l2.325,1.067M14.329,14.461c-.241-.259-.532-.243-.735-.486-.203-.243-.452-.247-.567-.305-.115-.058-.108-.169-.146-.156s-.025.138.116.243.272.048.523.343c.251.295.448.225.664.506",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.942,15.137l-2.325-1.067s-.014-.006-.026-.016c-.019-.017-.026-.038-.017-.059.014-.034.053-.035.084-.022l1.379.511c-.061-.048-.121-.078-.184-.11-.109-.055-.222-.112-.349-.262-.162-.19-.272-.23-.368-.266-.052-.019-.1-.036-.151-.074-.11-.082-.151-.18-.142-.236.005-.03.022-.04.031-.043.033-.011.049.02.062.046.017.034.04.081.101.111.029.015.069.026.115.04.129.037.306.088.459.271.099.118.219.174.347.232.13.06.264.121.387.253l-.031.028c-.117-.126-.248-.186-.374-.244-.132-.06-.257-.118-.362-.243-.144-.173-.314-.222-.438-.258-.048-.014-.09-.026-.122-.042-.073-.037-.101-.093-.119-.13-.004-.008-.008-.017-.012-.022-.001.003-.003.008-.003.016,0,.035.026.113.126.188.046.034.089.05.14.068.102.037.217.079.386.278.122.143.231.199.337.252.092.046.179.091.269.186l.914.339-.015.039-.844-.313s.002.002.003.004l-.033.025c-.017-.022-.033-.041-.049-.059l-1.475-.547c-.005-.002-.027-.009-.03,0-.003.008.017.019.021.021l2.325,1.067-.017.038Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M15.091,14.909l-1.875-1.739s-.034-.034-.057-.011.011.057.011.057l1.739,1.875M14.587,14.245c-.123-.332-.399-.428-.493-.731-.095-.303-.323-.401-.407-.499s-.035-.198-.075-.2-.076.117.015.269.233.149.352.517.328.379.42.721",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.894,15.105l-1.739-1.875s-.011-.011-.018-.025c-.011-.023-.009-.045.007-.061.026-.026.063-.012.086.011l1.078,1c-.038-.067-.082-.119-.128-.172-.08-.093-.162-.189-.223-.376-.077-.238-.163-.317-.239-.386-.04-.037-.079-.072-.111-.126-.07-.118-.071-.223-.041-.272.016-.026.035-.029.046-.028.035.002.037.038.039.066.002.038.006.09.05.141.021.025.054.051.091.081.105.084.249.199.32.426.046.147.136.244.232.347.097.105.198.213.261.382l-.039.015c-.06-.162-.158-.267-.252-.369-.099-.106-.192-.207-.241-.363-.067-.215-.205-.325-.306-.406-.039-.031-.073-.058-.097-.086-.054-.062-.058-.125-.06-.166-.001-.008-.001-.019-.002-.025-.002.002-.005.006-.009.014-.014.032-.02.114.045.222.029.049.064.08.103.117.08.073.17.156.25.404.058.179.137.272.214.362.067.078.131.152.178.275l.715.663-.028.031-.66-.612s.001.003.001.005l-.04.011c-.007-.026-.015-.051-.023-.073l-1.153-1.069s-.021-.018-.028-.012c-.006.006.008.024.011.027l1.74,1.876-.03.026Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4",
    "data-name": "b",
    d: "M14.085,15.162c-.34.017-.49.21-.799.172.245.083.434-.117.796-.106M14.972,14.941l-1.597.731,1.646-.612",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b5",
    "data-name": "b",
    d: "M14.092,14.799c-.32-.114-.533.006-.804-.147.194.17.446.058.776.207M14.997,14.935l-1.755.064,1.755.064",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b6",
    "data-name": "b",
    d: "M14.238,14.467c-.252-.228-.495-.198-.687-.444.114.232.39.224.637.488M15.022,14.938l-1.646-.612,1.597.731",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7",
    "data-name": "b",
    d: "M14.5,14.216c-.146-.307-.381-.372-.465-.673.017.258.274.356.402.695M15.044,14.951l-1.286-1.195,1.196,1.286",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M15.118,14.951l-1.067-2.325s-.018-.044-.048-.032c-.03.012-.011.057-.011.057l.889,2.398M14.907,14.145c.013-.354-.204-.548-.176-.864.028-.316-.145-.494-.185-.617s.043-.196.007-.214c-.036-.017-.115.079-.089.254s.158.226.127.612.158.475.112.827",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.862,15.056l-.889-2.398s-.006-.014-.007-.03c-.002-.026.009-.045.03-.054.034-.014.063.013.075.043l.614,1.337c-.009-.077-.03-.141-.052-.208-.038-.116-.078-.237-.062-.432.02-.249-.029-.355-.073-.448-.023-.05-.045-.097-.054-.159-.02-.135.02-.233.066-.267.024-.018.044-.013.053-.009.032.015.02.049.011.076-.012.036-.029.085-.008.15.01.031.03.067.053.109.065.118.154.279.133.516-.014.154.032.278.081.409.05.134.101.273.095.453l-.042-.002c.006-.172-.044-.307-.092-.437-.051-.136-.098-.265-.084-.428.02-.224-.065-.379-.128-.492-.024-.044-.045-.082-.057-.117-.026-.078-.006-.137.008-.176.003-.008.006-.018.007-.024-.003.001-.007.004-.013.009-.025.024-.062.098-.044.222.008.056.028.098.051.147.046.098.097.209.076.469-.015.188.023.304.06.416.032.098.063.191.059.322l.407.886-.036.021-.376-.818s0,.003-.001.005l-.041-.005c.004-.027.006-.052.007-.076l-.656-1.429c-.002-.005-.013-.025-.021-.022s-.001.026,0,.029l.89,2.399-.04.013Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M15.128,15l-.096-2.556s0-.048-.032-.048-.032.048-.032.048l-.096,2.556M15.242,14.174c.147-.322.021-.585.168-.865.147-.281.055-.512.065-.641.01-.129.115-.165.089-.195-.027-.03-.137.029-.18.201s.06.27-.117.614c-.176.344-.036.5-.213.807",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.893,15.001l-.042-.002.096-2.556s0-.015.005-.03c.008-.024.026-.038.048-.038.036,0,.053.036.053.069l.055,1.47c.021-.074.026-.142.031-.212.009-.122.019-.248.108-.423.114-.223.109-.339.104-.442-.002-.055-.005-.107.011-.168.033-.133.108-.208.163-.222.03-.007.045.005.052.012.023.026,0,.053-.019.074-.025.028-.059.067-.064.136-.002.033.002.074.007.122.015.134.036.317-.075.528-.071.137-.076.269-.082.409-.005.143-.011.291-.086.455l-.038-.017c.072-.157.077-.3.082-.439.005-.145.01-.282.086-.427.104-.199.085-.375.07-.504-.006-.05-.01-.093-.008-.129.006-.082.047-.129.075-.16.006-.006.013-.014.016-.02-.003,0-.008.001-.016.003-.032.013-.095.067-.125.189-.014.055-.012.102-.009.156.005.108.01.23-.109.463-.086.167-.095.289-.104.407-.008.102-.015.2-.069.32l.037.975-.042.002-.034-.9s-.002.003-.002.004l-.036-.021c.014-.024.025-.046.035-.068l-.059-1.572c0-.005-.002-.028-.011-.028s-.011.023-.011.027l-.093,2.557Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a10",
    "data-name": "a",
    d: "M15.119,15.049l.889-2.398s.018-.044-.011-.057c-.03-.012-.048.032-.048.032l-1.067,2.325M15.539,14.329c.259-.241.243-.532.486-.735.243-.203.247-.452.305-.567s.169-.108.156-.146-.138-.025-.243.116c-.105.142-.048.272-.343.523s-.225.448-.506.664",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.138,15.056l-.039-.015.313-.844s-.002.002-.004.003l-.025-.033c.022-.017.041-.033.059-.049l.547-1.475c.002-.005.009-.027,0-.03-.008-.003-.019.017-.021.021l-1.067,2.325-.038-.017,1.067-2.325s.006-.014.016-.026c.017-.019.038-.026.059-.017.034.014.035.053.022.084l-.511,1.379c.048-.061.078-.121.11-.184.055-.109.112-.222.262-.349.191-.162.23-.272.266-.368.019-.052.036-.1.074-.151.082-.11.18-.151.236-.142.03.005.04.022.043.031.012.033-.02.049-.046.062-.034.017-.08.04-.111.101-.015.029-.026.069-.04.115-.037.129-.088.306-.271.459-.118.099-.174.219-.232.347-.06.13-.121.264-.253.387l-.028-.031c.126-.117.186-.248.244-.374.06-.132.118-.257.243-.362.173-.144.222-.314.258-.438.014-.048.026-.09.042-.122.037-.073.093-.101.13-.119.008-.004.017-.008.022-.012-.003-.001-.008-.003-.016-.003-.035-.002-.113.026-.188.126-.034.046-.05.089-.068.14-.037.102-.079.217-.278.386-.143.122-.199.231-.252.337-.046.092-.091.179-.186.269l-.339.914Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11",
    "data-name": "a",
    d: "M15.091,15.091l1.739-1.875s.034-.034.011-.057-.057.011-.057.011l-1.875,1.739M15.755,14.587c.332-.123.428-.399.731-.493.303-.095.401-.323.499-.407.098-.084.198-.035.2-.075s-.118-.076-.269.015-.149.233-.517.352-.379.328-.721.42",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.106,15.105l-.031-.028.612-.66s-.003.001-.005.001l-.011-.04c.026-.007.051-.015.073-.023l1.069-1.153s.018-.021.012-.028c0-.001-.003-.004-.013.001-.008.004-.014.01-.014.01l-1.876,1.74-.028-.031,1.875-1.739s.011-.011.025-.018c.023-.012.045-.009.061.007.026.026.012.063-.011.086l-1,1.078c.067-.038.119-.082.172-.128.093-.08.189-.162.376-.223.238-.077.317-.163.386-.239.037-.04.072-.079.126-.111.118-.07.224-.071.272-.041.026.016.029.035.028.046-.002.035-.038.037-.066.039-.038.002-.09.006-.141.05-.025.021-.051.054-.081.091-.084.105-.199.249-.426.32-.147.046-.244.136-.347.232-.105.097-.213.198-.382.261l-.015-.039c.162-.06.267-.158.369-.252.106-.099.207-.192.363-.241.215-.067.325-.205.406-.306.031-.039.058-.073.086-.097.062-.054.125-.058.166-.06.008-.001.019-.001.025-.002-.002-.002-.006-.005-.014-.009-.032-.014-.114-.02-.222.045-.049.029-.08.064-.117.103-.073.08-.156.17-.404.25-.179.058-.272.137-.362.215-.078.067-.152.131-.275.178l-.661.715Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8",
    "data-name": "b",
    d: "M14.838,14.085c-.017-.34-.21-.49-.172-.799-.083.245.117.434.106.796M15.059,14.972l-.731-1.597.612,1.646",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b9",
    "data-name": "b",
    d: "M15.201,14.092c.114-.32-.006-.533.147-.804-.17.194-.058.446-.207.776M15.065,14.997l-.064-1.755-.064,1.755",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b10",
    "data-name": "b",
    d: "M15.533,14.238c.228-.252.198-.495.444-.687-.232.114-.224.39-.488.637M15.062,15.022l.612-1.646-.731,1.597",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b11",
    "data-name": "b",
    d: "M15.784,14.5c.307-.146.372-.381.673-.465-.258.017-.356.274-.695.402M15.049,15.044l1.195-1.286-1.286,1.196",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a12",
    "data-name": "a",
    d: "M15.049,15.118l2.325-1.067s.044-.018.032-.048c-.012-.03-.057-.011-.057-.011l-2.398.889M15.855,14.907c.354.013.548-.204.864-.176s.494-.145.617-.185c.123-.04.196.043.214.007.017-.036-.08-.115-.254-.089s-.226.158-.612.127c-.386-.031-.475.158-.827.112",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.058,15.137l-.018-.037.818-.376s-.003,0-.005-.001l.005-.041c.027.004.052.006.076.007l1.429-.656s.025-.013.022-.021-.026-.001-.03,0l-2.399.89-.015-.039,2.398-.889s.014-.006.03-.007c.026-.002.045.009.054.03.014.034-.013.063-.044.075l-1.337.613c.077-.009.141-.03.208-.052.116-.038.236-.078.432-.062.249.02.355-.029.448-.073.05-.023.097-.045.159-.054.136-.02.233.02.267.066.018.024.013.044.009.053-.015.032-.049.02-.076.011-.036-.012-.085-.029-.15-.008-.031.01-.067.03-.109.053-.118.065-.279.154-.516.133-.153-.014-.278.032-.409.081-.134.05-.272.101-.453.095l.002-.042c.173.007.307-.044.437-.092.136-.051.265-.098.428-.084.224.02.379-.065.492-.128.044-.024.082-.045.117-.057.078-.026.137-.005.176.008.008.003.018.006.024.007,0-.003-.004-.007-.009-.013-.024-.025-.098-.062-.222-.044-.056.008-.098.028-.147.051-.098.046-.209.098-.469.076-.187-.015-.304.023-.416.06-.098.032-.19.062-.322.059l-.885.408Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a13",
    "data-name": "a",
    d: "M15,15.128l2.556-.096s.048,0,.048-.032-.048-.032-.048-.032l-2.556-.096M15.826,15.242c.322.147.585.021.865.168.281.147.512.055.641.065.129.01.165.115.195.089.03-.027-.029-.137-.201-.18s-.27.06-.614-.117c-.344-.176-.5-.036-.807-.213",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.517,15.588c-.018,0-.036-.016-.051-.029-.028-.025-.067-.059-.136-.064-.033-.003-.074.002-.122.007-.134.015-.317.036-.528-.075-.137-.071-.269-.076-.409-.082-.143-.005-.291-.011-.455-.086l.017-.038c.157.072.3.077.439.082.145.005.282.01.427.086.2.104.375.085.504.07.05-.006.093-.01.129-.008.082.006.129.047.16.075.006.006.014.013.02.016,0-.003,0-.008-.004-.016-.013-.032-.067-.095-.189-.125-.055-.014-.102-.012-.156-.009-.108.005-.23.01-.463-.109-.167-.086-.289-.095-.407-.104-.102-.008-.2-.015-.32-.069l-.975.037-.002-.042.9-.034s-.003-.002-.004-.002l.021-.036c.024.014.046.025.068.035l1.572-.059s.028-.002.028-.011-.023-.011-.027-.011l-2.557-.096.002-.042,2.556.096h0c.032,0,.068.017.068.053s-.036.053-.069.053h0l-1.47.055c.074.021.142.026.212.031.122.009.248.019.423.108.223.114.339.109.442.104.055-.002.107-.005.168.011.133.033.208.108.222.163.007.029-.005.045-.012.052-.006.011-.014.013-.022.013Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a14",
    "data-name": "a",
    d: "M14.951,15.119l2.398.889s.044.018.057-.011c.012-.03-.032-.048-.032-.048l-2.325-1.067M15.671,15.539c.241.259.532.243.735.486.203.243.452.247.567.305.115.058.108.169.146.156s.025-.138-.116-.243-.272-.048-.523-.343c-.251-.295-.448-.225-.664-.506",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.112,16.509c-.024,0-.037-.027-.048-.048-.017-.034-.04-.081-.101-.111-.029-.015-.069-.026-.115-.04-.129-.037-.306-.088-.459-.271-.099-.118-.219-.174-.347-.232-.13-.06-.264-.121-.387-.253l.031-.028c.117.126.248.186.374.244.132.06.257.118.362.243.144.173.314.222.438.258.048.014.09.026.122.042.073.037.101.093.119.13.004.008.008.017.012.022,0-.003.003-.008.003-.016,0-.035-.026-.113-.126-.188-.046-.034-.089-.05-.14-.068-.102-.037-.217-.079-.386-.278-.122-.143-.231-.199-.337-.252-.092-.046-.179-.091-.269-.186l-.914-.339.015-.039.844.313s-.002-.002-.003-.004l.033-.025c.017.022.033.041.049.059l1.475.547s.027.009.03,0c.003-.008-.017-.019-.021-.021l-2.325-1.067.017-.038,2.325,1.067c.03.012.057.041.043.075-.014.034-.053.035-.084.022l-1.379-.511c.061.048.121.078.184.11.109.055.222.112.349.262.162.191.272.23.368.266.052.019.1.036.151.074.11.082.151.179.142.236-.005.03-.022.04-.031.043-.005.001-.009.002-.014.002Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a15",
    "data-name": "a",
    d: "M14.909,15.091l1.875,1.739s.034.034.057.011c.023-.023-.011-.057-.011-.057l-1.739-1.875M15.413,15.755c.123.332.399.428.493.731.095.303.323.401.407.499s.035.198.075.2.076-.117-.015-.269c-.091-.151-.233-.149-.352-.517-.119-.368-.328-.379-.42-.721",
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.39,17.206h-.002c-.035-.002-.037-.038-.039-.066-.002-.038-.006-.09-.05-.141-.021-.025-.054-.051-.091-.081-.105-.084-.249-.199-.32-.426-.046-.147-.136-.244-.232-.347-.097-.105-.198-.213-.261-.382l.039-.014c.06.161.158.267.252.368.099.106.192.207.241.363.067.215.205.325.306.406.039.031.073.058.097.086.054.062.058.125.06.166,0,.008,0,.019.002.025.002-.002.005-.006.009-.014.014-.032.02-.114-.045-.222-.029-.049-.064-.08-.103-.117-.08-.073-.17-.156-.25-.404-.058-.179-.137-.272-.214-.362-.067-.078-.131-.152-.178-.275l-.715-.663.028-.031.66.612s-.001-.003-.001-.004l.04-.011c.007.026.015.05.023.073l1.153,1.07s.021.018.028.012c.006-.006-.008-.024-.011-.027l-1.74-1.876.031-.028,1.739,1.875c.023.023.037.06.011.086-.026.026-.063.012-.086-.011l-1.078-1c.038.067.082.119.128.172.08.093.162.189.223.376.077.238.163.317.239.386.04.037.079.072.111.126.07.117.071.223.041.272-.017.024-.035.028-.045.028Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b12",
    "data-name": "b",
    d: "M15.915,14.838c.34-.017.49-.21.799-.172-.245-.083-.434.117-.796.106M15.028,15.059l1.597-.731-1.646.612",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b13",
    "data-name": "b",
    d: "M15.908,15.201c.32.114.533-.006.804.147-.194-.17-.446-.058-.776-.207M15.003,15.065l1.755-.064-1.755-.064",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b14",
    "data-name": "b",
    d: "M15.762,15.533c.252.228.495.198.687.444-.114-.232-.39-.224-.637-.488M14.978,15.062l1.646.612-1.597-.731",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b15",
    "data-name": "b",
    d: "M15.5,15.784c.146.307.381.372.465.673-.017-.258-.274-.356-.402-.695M14.956,15.049l1.286,1.195-1.196-1.286",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1.042,
    style: {
      fill: "#f6b40e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,16.07c-.59,0-1.07-.48-1.07-1.07s.48-1.07,1.07-1.07,1.07.48,1.07,1.07-.48,1.07-1.07,1.07ZM15,13.986c-.559,0-1.014.455-1.014,1.014s.455,1.014,1.014,1.014,1.014-.455,1.014-1.014-.455-1.014-1.014-1.014Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M15.355,14.777c-.071,0-.139.031-.179.095.08.072.257.08.377-.008-.051-.055-.123-.086-.198-.087h0ZM15.354,14.794c.069-.001.134.031.143.062-.08.088-.208.08-.288.016.035-.056.091-.077.145-.078h0Z",
    style: {
      fill: "#843511"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M15.369,14.728c-.104,0-.128.024-.176.064-.048.04-.072.032-.08.04s0,.032.016.024c.016-.008.048-.024.096-.064.048-.04.096-.04.144-.04.144,0,.224.12.24.112s-.08-.136-.24-.136h0Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M15.657,14.776c-.184-.16-.417-.184-.545-.064-.031.042-.051.087-.06.134-.016.091.012.19.084.291-.008,0-.024.008-.032.016-.064-.122-.086-.247-.065-.365.006-.031.014-.062.025-.091.176-.146.417-.162.593.079h0Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f",
    cx: 15.353,
    cy: 14.856,
    r: 0.072,
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M15.561,14.904c-.136.104-.272.096-.353.048-.08-.048-.08-.064-.064-.064s.032.016.096.048c.065.032.161.032.321-.032h0Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.841,15.144c-.034.006-.059.037-.059.071,0,.04.033.071.073.071.023,0,.045-.011.059-.03.028.021.066.023.087.023h.009c.021,0,.059-.003.087-.023.013.019.035.03.059.03.04,0,.073-.032.073-.071,0-.035-.024-.065-.059-.071.019.007.032.025.032.046,0,.027-.021.048-.048.048h0c-.025,0-.047-.02-.048-.046-.008.016-.039.062-.1.064-.061-.002-.092-.049-.1-.064-.002.025-.023.046-.048.046-.027,0-.048-.021-.048-.048h0c0-.021.011-.039.031-.046h0ZM14.919,15.357c-.08,0-.112.073-.184.121.04-.016.072-.048.128-.08.056-.032.104.007.136.007h.001c.032,0,.08-.039.136-.007s.089.064.129.08c-.072-.048-.105-.121-.185-.121-.016,0-.048.009-.08.025h-.001c-.032-.016-.064-.025-.08-.025Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.892,15.452c-.032.001-.073.008-.134.026.144-.032.176.016.24.016h.002c.064,0,.096-.048.24-.016-.16-.048-.192-.016-.24-.016h-.001c-.03,0-.054-.012-.107-.01h0Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.766,15.477c-.009,0-.019,0-.03.001.168.016.087.113.264.113h0c.176,0,.097-.096.265-.113-.176-.016-.121.088-.265.088h-.001c-.135,0-.094-.091-.233-.089h0ZM15.144,15.737c0-.08-.065-.144-.144-.144-.08,0-.144.065-.144.144.016-.067.076-.114.144-.114.069,0,.129.047.144.114Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e1",
    "data-name": "e",
    d: "M14.352,14.776c.184-.16.417-.184.545-.064.031.042.051.087.06.134.016.091-.012.19-.084.291.008,0,.024.008.032.016.064-.122.086-.247.065-.365-.006-.031-.014-.062-.025-.091-.176-.146-.416-.162-.593.079h0Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1",
    "data-name": "d",
    d: "M14.641,14.728c.104,0,.128.024.176.064.048.04.072.032.08.04s0,.032-.016.024-.048-.024-.096-.064c-.048-.04-.096-.04-.144-.04-.144,0-.224.12-.24.112-.017-.008.08-.136.24-.136h0Z",
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h1",
    "data-name": "h",
    d: "M14.636,14.777c-.071,0-.139.031-.179.095.08.072.257.08.377-.008-.052-.055-.123-.086-.198-.087h0ZM14.635,14.794c.069-.001.134.031.143.062-.08.088-.208.08-.288.016.034-.056.091-.077.145-.078h0Z",
    style: {
      fill: "#843511"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f1",
    "data-name": "f",
    cx: 14.645,
    cy: 14.856,
    r: 0.072,
    style: {
      fill: "#85340a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "g1",
    "data-name": "g",
    d: "M14.448,14.904c.136.104.272.096.353.048.08-.048.08-.064.064-.064s-.032.016-.096.048c-.064.032-.16.032-.321-.032h0Z",
    style: {
      fill: "#85340a"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.627fe5317e120565023d02c42b79457d.svg";
export { ForwardRef as ReactComponent };